import React from 'react';

/**
 * Topic pill bar within the active section plus the scrollable HTML content
 * pane for the selected topic.
 */
export default function HelpContent({ section, activeTopicId, onSelectTopic }) {
  if (!section) return null;
  const topic = section.topics.find((t) => t.id === activeTopicId) || section.topics[0];

  return (
    <>
      {section.topics.length > 1 && (
        <div className="help-topics" role="tablist" aria-label={`${section.title} topics`}>
          {section.topics.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={t.id === topic.id}
              className={`help-pill${t.id === topic.id ? ' active' : ''}`}
              onClick={() => onSelectTopic(t.id)}
            >
              {t.title}
            </button>
          ))}
        </div>
      )}
      <div className="help-content" tabIndex={0}>
        <h6 className="fw-bold text-brand-primary mb-3">{topic.title}</h6>
        {/* Help bodies are static, authored HTML from helpContent.js. */}
        <div dangerouslySetInnerHTML={{ __html: topic.body }} />
      </div>
    </>
  );
}
